export default "__VITE_ASSET__DBzEaWTR__"